import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M20.21 7.99a2 2 0 1 0-1.827-.813L15.79 13.01a2 2 0 0 0-.73.223L10 10.07V10a2 2 0 1 0-3.67 1.102l-2.45 4.901a2 2 0 1 0 1.79.895l2.45-4.901c.295-.018.572-.1.82-.23L14 14.93V15a2 2 0 1 0 3.617-1.177z"
    }
  )
);
var SvgStatsOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var StatsOutlined_default = SvgStatsOutlined;

export { StatsOutlined_default as default };
